import React, { useMemo } from "react";
import ItemSelector from "./ItemSelector";
import { createLanguageOptions, PLATFORM_LANGUAGE_CODES } from "@/utils/languageUtil";
import { useLanguage } from "@/hooks/useLanguage";

interface ItemLanguageSelectorProps {
  name: string;
  multi?: boolean;
  placeholder?: string;
  disabled?: boolean;
  handleChange?: (value: unknown) => void;
  isClearable?: boolean;
}

const ItemLanguageSelector: React.FC<ItemLanguageSelectorProps> = (props) => {
  const language = useLanguage();
  const languageList = useMemo(() => {
    const languageItems = createLanguageOptions(PLATFORM_LANGUAGE_CODES, language);
    return languageItems.sort((a, b) => a.label.localeCompare(b.label));
  }, [language]);

  return <ItemSelector {...props} options={languageList} />;
};

export default ItemLanguageSelector;